<template>
	<div class="EDIDetail componetself" v-loading="pageload">
		<div class="componet_header">
			<div class="filter">
				<template v-for="(item,index) in  filterList">
					<div class="filter_item" :key="index">
						<c-filter :item="item" 
							:form="filterForm" :line="true" :textMini="45"></c-filter>
					</div>
				</template>
			</div>
			<div class="btns">
				<el-button type="primary" class="pursh_mainBtn" :loading="selectLog" :disabled="selectLog" @click="selectOrder">查询</el-button>
			</div>
		</div>
		<div class="componet_body">
			<div class="detail_head">
				<table>
					<tr>
						<td>发送方代码</td>
						<td>{{sendid}}</td>
						<td>接收方代码</td>
						<td>{{recievedid}}</td>
					</tr>
				</table>
			</div>
			<div class="body_content">
				<!-- checkbox -->
				<c-table ref="ctablemain" :table="table" :coltype="'seq'"
					@FitColumns="table.head=$event"></c-table>
				
			</div>
		</div>
	</div>
</template>

<script>
	import {detailFilter} from './filter.js';
	import {detailHead} from './tablehead.js'
	export default{
		props:{
			menuId:{
				type:String,
				default:''
			}
		},
		data(){
			return{
				filterForm:{},
				table: {
					pagesize: 15,
					currentPage: 1,
					head: [],
					data: [],
					_height: undefined
				},
				selectLog:false,
				pageload:true,
				sendid:'',
				recievedid:''
			}
		},
		computed:{
			filterList(){
				let filter=JSON.parse(JSON.stringify(detailFilter));
				let ljset=new Set();
				console.log(filter)
				filter[0]['dataSource']=[];
				this.table.data.map(item=>{
					let firs=ljset.size;
					ljset.add(item['零件号']);
					if(firs!=ljset.size)
						filter[0]['dataSource'].push({'零件号':item['零件号']});
				});
				return filter;
			},
			GetCurrentTab(){
				if(this.menuId=='')
					return {};
				else{
					return this.$store.getters.GetOpenedTabs.find(i=>i.menuId==this.menuId);
				}
			},
			GetRouteData(){
				return this.GetCurrentTab.route;
			}
		},
		methods:{
			selectOrder(btn){
				try{
					console.log(this.GetRouteData)
					let {_id}= this.GetRouteData.order;
					if(!_id) throw '重要参数为空';
					if(this.selectLog||(!btn&&!this.pageload)) return;
					if(btn) this.selectLog=true;
					else this.pageload=false;
					this.$BH().base.http({
						url:'Web/GETEDIHDETAIL',
						data:{
							filterList:this.filterList,
							filterform:this.filterForm,
							FIDENTITY_ID:_id
						},
						success:(res)=>{
							console.log(res)
							let {value}=res.data;
							this.table.data=value;
							this.$refs.ctablemain?.updateCoulm();
							
							if(value.length>0){
								this.sendid=value[0]['发送方代码']
								this.recievedid=value[0]['接收方代码']
							}
								
						},
						loadingcontrol:()=>{
							this.selectLog=false;
							this.pageload=false;
						}
					})
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
					this.selectLog=false;
					this.pageload=false;
					
				}
			}
		},
		mounted() {
			setTimeout(()=>{
				this.$refs.ctablemain?.updateCoulm();
			},0);
		},
		created() {
			this.table.head=detailHead;
			//自动获取数据
			this.selectOrder()
		}
	}
</script>

<style>
</style>